import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BackendService } from '../../core/backend.service';
import { NotificacionWho } from '../notificacionWho.model';
import { Notificacion } from '../notificacion.model';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { NgForm } from '@angular/forms';
import { SnackService } from '../../shared-services/snack.service';

@Component({
  selector: 'app-notificacion-id',
  templateUrl: './notificacion-id.component.html',
  styleUrls: ['./notificacion-id.component.scss']
})
export class NotificacionIdComponent implements OnInit {

  notificacion: Notificacion;
  notificacionesWho: NotificacionWho[];
  notificacionWho: Partial<NotificacionWho> = {};

  textPattern = /.*\S.*/;

  id: number;

  @ViewChild('form') public notificacionForm: NgForm;

  constructor(private backendService: BackendService,
    private activatedRoute: ActivatedRoute,
    private snackService: SnackService) { }

  async ngOnInit() {
    const route = this.activatedRoute.snapshot;
    this.id = route.params.id;
    this.getNotificacion(this.id);
    this.getHilo(this.id);
  }

  async getNotificacion(id){
    await this.backendService.get(Notificacion, Notificacion.path + id).toPromise().then((notificacion)=>
    {
      this.notificacion = notificacion;
    });
  }

  async getHilo(id: number){
    await this.backendService.get(NotificacionWho, "/notificaciones/respuesta/" + id, null).toPromise().then((notificacionesWho)=>{
      this.notificacionesWho = notificacionesWho;
    })
  }

  async responder(){
    this.snackService.spinner(true);
    if(this.validateForm()){
      this.setRespuesta();
      await this.saveRespuesta();
      await this.ngOnInit();
      this.notificacionWho.respuesta = "";      
    } else {
      this.snackService.error("Debe ingresar una respuesta");
    }
    this.snackService.spinner(false);
  }

  validateForm() {
    if(this.notificacionWho.respuesta){
      if(this.textPattern.test(this.notificacionWho.respuesta)){
        return true;
      }
    }
    return false;
  }

  setRespuesta(){
    this.notificacionWho.notificacionId = this.notificacion.id;
    this.notificacionWho.leido = false;
  }

  async saveRespuesta(){
    await this.backendService.create("/notificaciones/respuesta", this.notificacionWho).then((data)=>{
      if(data){
        this.snackService.success("Se envió la respuesta correctamente");
      } else {
        this.snackService.error("Hubo un error al enviar la notificacion");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/notificacion/notificacion-id/notificacion-id.component.ts